// axios.defaults.baseURL = "http://127.0.0.1:3000";
// Y.axios.defaults.maxContentLength = 65535;
// axios.defaults.headers.post["Content-Type"] = "application/json";
Y.User.nickname = Y.Local.get("nickname") || "";
Y.User.token = Y.Local.get("token") || "";
document.documentElement.style.fontSize = document.body.clientWidth / 12 + "px";
// 添加请求拦截器
Y.Axios.interceptors.request.use(
    function(config) {
        // config.headers.YWT = Y.Local.get("ywt", "0");
        return config;
    },
    function(error) {
        return Promise.reject(error);
    }
);

// 添加响应拦截器
Y.Axios.interceptors.response.use(
    function(response) {
        if (response.data) {
            return response.data;
        } else {
            return { code: "ko", msg: "默认消息" };
        }
    },
    function(error) {
        return Promise.reject(error);
    }
);

// 添加获取临时令牌队列
Y.LoopQueue.push(function() {
    // 获取临时ywt
    var ywt = Y.Local.get("ywt");
    if (ywt) {
        // 每10秒判断一次是否过期
        var nowTime = Date.now();
        if (nowTime - Y.Time.getTempYWT < 10000) return;
        Y.Time.getTempYWT = nowTime;

        if (ywt) {
            var hash = Y.YWTAuth();
            if (hash === false) return false;
            if (hash.expire > Date.now()) return false;
        }
    }
    Y.Axios.post(Y.Api, {
        cmd: "getTempYWT"
    }).then(function(reply) {
        if (reply.code === "ok") {
            Y.Local.set("ywt", reply.data.ywt);
        }
    });
});

// 设置菜单
Y.Menu = Y.GetLocationParams()["menu"];
// 循环器
function LOOP() {
    Y.LoopQueue.forEach(function(func) {
        func();
    });
    setTimeout(LOOP, 1000);
}
// LOOP();
// Y.Axios.get(G.Api + "/home/index").then(function(reply) {
//     if (reply.msg === "success") {
//         Y.Footer = reply.data;
//     }
// });
